import mixpanel from "mixpanel-browser";
import { LoaderFunction, Outlet } from "react-router";

import { DesignSystemProvider } from "@icg360/design-system";

import { AppLoaderData, DataField, ProposalData } from "./types";
import { identify } from "./utils/feature-flags";

const API_BASE_URL = import.meta.env.VITE_API_URL as string;
export const appLoader: LoaderFunction = async ({
  params
}): Promise<AppLoaderData> => {
  const endpoint = `${API_BASE_URL}/api/rest/v1/quoteproposal/${params.proposal}`;
  const res = await fetch(endpoint);

  if (res.status !== 200) {
    throw res;
  }

  const data = (await res.json()) as ProposalData;
  // TODO: we're not getting the new flags immediately after this
  void identify({
    kind: "user",
    key: params.proposal,
    producerName: data.producer.name
  });
  try {
    mixpanel.register({
      roofResealingStripeIntentStatus:
        data.quote.roofResealingStripeIntentStatus,
      producerName: data.producer.name,
      agencyName: data.producer.agency,
      quoteId: data.quoteNumber,
      proposalId: params.proposal
    });
  } catch (_e) {
    // ignore errors
  }

  const sectionFieldsMap = data.quote.sections[0].fields.reduce(
    (fields, field) => {
      fields[field.term] = field.value;
      return fields;
    },
    {} as Record<string, DataField["value"]>
  );

  return {
    ...data,
    sectionFieldsMap
  };
};

export const App = () => (
  <DesignSystemProvider>
    <Outlet />
  </DesignSystemProvider>
);
